import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { SELLER_ID_SAE } from '../../order'
import { productIsOwnBrand } from '../../product'
import { type UdpTrackingProduct } from '../../udp-tracking'

const recommendationPriceToCents = (price: string): number =>
  Math.round(Number(price) * 100)

export const recommendationUdpTrackingBuildProduct = ({
  isSponsored,
  product,
}: {
  isSponsored: boolean
  product: GkAirRecommendedProductDataWeb
}): UdpTrackingProduct => ({
  is_marketplace: product.seller_id !== SELLER_ID_SAE,
  is_own_brand: product.brand !== undefined && productIsOwnBrand(product.brand),
  is_sponsored: isSponsored,
  price: {
    amount: recommendationPriceToCents(product.price),
    discount: Number(product.discount_in_percent),
    ...(product.reduced === 'true' &&
      product.strike_through_price !== null && {
        strike_price: recommendationPriceToCents(product.strike_through_price),
      }),
  },
  rating: Number(product.rating_average),
  seller: {
    id: product.seller_id,
  },
  upid: product.UID,
})
